import React from 'react'
import Logo from "../assets/logo.jpg";


function Footer() {
  return (
    <div>
<footer class="bg-white rounded-lg shadow-md   border">
    <div class="w-full max-w-screen-xl mx-auto p-4 md:py-8">
        <div class="sm:flex sm:items-center sm:justify-between">
        <a href="/" className="flex items-center space-x-3 mb-2 sm:mb-0">
            <img src={Logo} className="size-10 rounded-full" alt="Logo" />
            <span className="self-center text-myBlack text-2xl font-semibold whitespace-nowrap">
              <span className="font-bold">AL</span>Guidance.lk
            </span>
          </a>
            <ul class="flex flex-wrap items-center mb-6 text-sm font-medium text-gray-500 sm:mb-0 dark:text-gray-400">
                <li>
                    <a href="#tutors" class="hover:underline me-4 md:me-6">Tutors</a>
                </li>
                <li>
                    <a href="#" class="hover:underline me-4 md:me-6">Privacy Policy</a>
                </li>
                <li>
                    <a href="#" class="hover:underline me-4 md:me-6">Licensing</a>
                </li>
                <li>
                    <a href="#support" class="hover:underline">Support</a>
                </li>
            </ul>
        </div>
        <hr class="my-6  sm:mx-auto bg-myBlue border-myBlue lg:my-8" />
        <span class="block text-sm text-gray-500 sm:text-center dark:text-gray-400">© 2024 <a href="https://devx.team.com/" class="hover:underline">DevX™</a>. All Rights Reserved.</span>
    </div>
</footer>


    </div>
  )
}

export default Footer